var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActeioLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48",
    width: 200,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Acteio Logo \u2014 Light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 36 L20 4 L36 36",
    stroke: "#1A1916",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 36,
    r: 4.5,
    fill: "#C4955A"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 34,
    fontFamily: "Syne, Arial, sans-serif",
    fontWeight: 400,
    fontSize: 26,
    letterSpacing: 3,
    fill: "#1A1916"
  }, "ACTE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 34,
    fontFamily: "Syne, Arial, sans-serif",
    fontWeight: 400,
    fontSize: 26,
    letterSpacing: 3,
    fill: "#C4955A"
  }, "IO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActeioLogo);
export default __webpack_public_path__ + "static/media/acteio-logo.430b063d7a4791bf9cf78768b4d2bcaa.svg";
export { ForwardRef as ReactComponent };